<template>
    <div ref="search" class="my-lg">
        <SearchBox />

        <div class="filters">
            <RefinementDropdown attribute="pointsOption" label="Type" :options="['Core', 'Elective']" />
            <LocationDropdown attribute="location" label="Location" :all-states="states" />
        </div>

        <div v-if="loading" class="text--center">
            <img src="/dist/images/loader.gif" alt="Loading...">
        </div>

        <template v-else-if="results && results.value.length">
            <div class="result-header">
                <div>
                    <p class="h6 text--grey-light">Points</p>
                    <p class="h6 text--grey-light">Location</p>
                </div>
                <p class="h6 text--grey-light">Course</p>
            </div>
            <Post v-for="post in paginatedResults" :key="post.id" :post="post" :states="states" />
            <Pagination :subset.sync="paginatedResults" :set="results.value" :items-per-page="10" @page-change="scrollTop" />
        </template>

        <p v-else class="my-xl text--center">
            No results found.
        </p>
    </div>
</template>

<script>
import axios from 'axios';
import { init } from '../searchy';
import SearchBox from './components/SearchBox.vue';
import LocationDropdown from './components/LocationDropdown.vue';
import RefinementDropdown from './components/RefinementDropdown.vue';
import Pagination from './components/Pagination.vue';
import Post from './components/Post.vue';
// import dummyData from './data.json';

export default {
    components: {
        LocationDropdown,
        RefinementDropdown,
        SearchBox,
        Pagination,
        Post
    },

    data() {
        return {
            loading: true,
            results: null,
            paginatedResults: null,
            states: ['New South Wales', 'Victoria', 'South Australia', 'Queensland', 'Western Australia', 'Tasmania', 'Northern Territory', 'ACT']
        };
    },

    async created() {
        const { data } = await axios.get('/api/courses.json');

        this.results = await init({
            dataset: data.data
        });

        this.loading = false;
    },

    methods: {
        scrollTop() {
            const el = document.querySelector('#courses-wrapper');
            el.scrollIntoView();
        }
    }
};
</script>

<style lang="scss" scoped>
    .filters {
        margin: 1.5em 0 2.5em;

        @media screen and (min-width: 600px) {
            display: flex;
        }

        > div {
            @media screen and (min-width: 600px) {
                flex: 1;
                margin-left: 2em;
            }

            &:first-child {
                margin-bottom: 1em;

                @media screen and (min-width: 600px) {
                    margin-left: 0;
                    margin-bottom: 0;
                }
            }
        }
    }

    .result-header {
        display: grid;
        grid-template-columns: 2fr 3fr;
        grid-column-gap: 55px;
        margin-bottom: 0.75em;

        div {
            display: flex;

            p:first-child {
                width: 120px;
                margin-right: 3rem;
            }
        }

        @media only screen and (max-width: 1023px) {
            display: none;
        }
    }

    .text--center {
        text-align: center;
    }
</style>